export const TEST_FUNDING_CATEGORY = "6225a3097cd8ef00a1fa0d8b";
export const STAGING_FUNDING_CATEGORY = "623d5641e1b5659d7e3de3ea";
export const PRODUCTION_FUNDING_CATEGORY = "63fa6ede1bfe96e6c615ec91";
